import styled, { css } from "styled-components";

export {
  GridContainer,
  SumaryContentColumn,
  AlignDataContainer,
  SumaryDataTitle,
  SumaryData,
  ShipmentsContainer,
  ProductListsTitle,
  NumberOfProducts,
  StatusContainer,
  NotesContainerAlign,
  NotesContainer,
  ActivityTextArea,
  BillingText,
  ActionsContainer,
  ActionButton,
} from "../OrderDetails.shared.styles";

export const Separator = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors["gray-400"]};
`;

export const HorizontalContainer = styled.div`
  display: flex;

  justify-content: space-between;
`;

interface ShipStatus {
  variant: string;
}

export const ShipContainer = styled.div<ShipStatus>`
  display: flex;
  align-items: center;

  background-color: ${(props) => props.theme.colors["green-150"]};
  color: ${(props) => props.theme.colors["green-800"]};

  height: 2rem;
  padding: 1rem;
  gap: 0.5rem;

  ${(props) =>
    props.variant !== "SHIPPED" &&
    css`
      background-color: ${(props) => props.theme.colors["red-300"]};
      color: ${(props) => props.theme.colors["gray-900"]};
    `}
`;

export const ShipmentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  gap: 1.5rem;
  margin-top: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    display: flex;
    flex-direction: column;

    gap: 0.75rem;
    margin-top: 0.75rem;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    gap: 0.75rem;
  }
`;

export const TableContainer = styled.div`
  max-height: 28rem;
  overflow: auto;
  overflow-x: hidden;

  margin-top: 1rem;

  table {
    padding-right: 0.5rem;
  }

  thead {
    position: sticky;
    top: 0;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors["gray-400"]};
    border-radius: ${(props) => props.theme.borderRadius.SM};
  }

  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors["gray-400"]};
    border-radius: ${(props) => props.theme.borderRadius.SM};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors["gray-700"]};
  }
`;

export const ActivityContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    display: flex;
    flex-direction: column;
  }
`;

export const ActivityAlign = styled.div`
  flex: 1;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    margin-top: 1.5rem;
  }
`;

export const ActivityContent = styled.div`
  max-height: 15rem;

  margin-top: 0.5rem;
  margin-bottom: 1.625rem;

  overflow: auto;
  overflow-x: hidden;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin: 0;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors["gray-400"]};
    border-radius: ${(props) => props.theme.borderRadius.SM};
  }

  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors["gray-400"]};
    border-radius: ${(props) => props.theme.borderRadius.SM};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors["gray-700"]};
  }
`;

export const ActivityReport = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 2rem;
  margin-right: 1rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    margin: 0;
  }
`;

export const ActivityDate = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  color: ${(props) => props.theme.colors["gray-850"]};

  span {
    color: ${(props) => props.theme.colors["gray-850"]};
  }
`;

export const BillingContainer = styled.div`
  display: flex;
  margin-top: 1.5rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    flex-direction: column;
  }
`;

export const BillingTextContainer = styled.div`
  flex: 1;
  border-right: 1px solid ${(props) => props.theme.colors["gray-400"]};

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    border: none;
  }
`;

export const BillingAlignContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const BillingTitleContainer = styled.div`
  display: flex;
  align-items: center;

  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const BillingTitle = styled.h4`
  font-size: ${(props) => props.theme.fontSize.XXS};
  font-weight: ${(props) => props.theme.fontWeight.Medium};
  color: ${(props) => props.theme.colors["gray-850"]};
`;

export const PriceContainer = styled.section`
  margin-top: 1.5rem;
`;

export const PriceDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  margin-top: 1.5rem;
`;

interface PriceProps {
  variant?: "discount" | "total";
}

export const PriceWrapper = styled.div<PriceProps>`
  display: flex;
  align-items: center;
  gap: 1.75rem;

  font-size: ${(props) => props.theme.fontSize.XXS};
  font-weight: ${(props) => props.theme.fontWeight.Regular};
  color: ${(props) => props.theme.colors["black-925"]};

  & > p:first-child {
    width: 4.5rem;
  }

  span {
    color: ${(props) => props.theme.colors["gray-850"]};
  }

  ${(props) => {
    if (props.variant === "discount") {
      return css`
        & > p:last-child {
          color: ${(props) => props.theme.newColors["red-500"]};
        }
      `;
    }

    if (props.variant === "total") {
      return css`
        & > p:last-child {
          color: ${(props) => props.theme.colors["green-800"]};
        }
      `;
    }
  }}
`;
